import { useEffect } from "react";
import Hero from "@/components/landing/Hero";
import WhyItMatters from "@/components/landing/WhyItMatters";
import ForEveryone from "@/components/landing/ForEveryone";
import HowItFeels from "@/components/landing/HowItFeels";
import Frameworks from "@/components/landing/Frameworks";
import ClassBands from "@/components/landing/ClassBands";
import ReportPreview from "@/components/landing/ReportPreview";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";

export default function Landing() {
  useEffect(() => {
    const io = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && (e.target.classList.add("is-in"), io.unobserve(e.target))), { threshold: 0.12 });
    document.querySelectorAll("[data-reveal]").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
  return (
    <div className="bg-ds-cream" data-testid="landing-page">
      <Hero />
      <WhyItMatters />
      <Frameworks />
      <ForEveryone />
      <ClassBands />
      <HowItFeels />
      <ReportPreview />
      <Pricing />
      <FAQ />
      <FinalCTA />
    </div>
  );
}
